appSocial.constant('SocialConfig', {
    api: {
        hosts: {
            dev: {
                url: {
                    http: 'https://social.pandats-api.com',
                    ws: 'wss://social.pandats-api.com/ws'
                }
            }
        }
    },
    defaultLang: 'en',
    fakeAvatars: true
})
